import React__default from 'react';
import classnames from 'classnames';
import { Heading } from '@grandvisionhq/elements';
import { Icon } from '@grandvisionhq/icons';

const ProductDetailDisclaimer = ({ className , disclaimer  })=>/*#__PURE__*/ React__default.createElement("section", {
        className: classnames('product-detail-disclaimer', className)
    }, /*#__PURE__*/ React__default.createElement("div", {
        className: "product-detail-disclaimer__header"
    }, /*#__PURE__*/ React__default.createElement(Icon, {
        className: "product-detail-disclaimer__icon",
        name: "info",
        "data-t": "disclaimer-icon"
    }), /*#__PURE__*/ React__default.createElement(Heading, {
        variant: "subheading1",
        component: "h3",
        className: "product-detail-disclaimer__title"
    }, disclaimer.title)), /*#__PURE__*/ React__default.createElement("div", {
        className: "product-detail-disclaimer__description"
    }, disclaimer.description))
;

export { ProductDetailDisclaimer };
//# sourceMappingURL=ProductDetailDisclaimer.js.map
